/* Product template data scripts — add as needed */
(function() {
    const track = document.getElementById('sliderTrack');
    const prevBtn = document.getElementById('sliderPrev');
    const nextBtn = document.getElementById('sliderNext');
    const dots = document.querySelectorAll('.gallery-dot');
    if (!track || !prevBtn || !nextBtn) return;

    const slides = track.querySelectorAll(':scope > div');
    const totalSlides = (typeof wp_total_images !== 'undefined' && wp_total_images > 0)
        ? wp_total_images
        : (window.product_data?.images?.length || slides.length);
    let currentSlide = 0;

    const updateSlider = () => {
        track.style.transform = 'translateX(-' + (currentSlide * 100) + '%)';
        dots.forEach((d, i) => {
            d.classList.toggle('bg-violet-500', i === currentSlide);
            d.classList.toggle('w-6', i === currentSlide);
            d.classList.toggle('bg-slate-300', i !== currentSlide);
            if (i !== currentSlide) d.classList.remove('w-6');
        });
    };

    prevBtn.onclick = () => {
        currentSlide = (currentSlide - 1 + totalSlides) % totalSlides;
        updateSlider();
    };
    nextBtn.onclick = () => {
        currentSlide = (currentSlide + 1) % totalSlides;
        updateSlider();
    };
    dots.forEach(d => {
        d.onclick = () => {
            currentSlide = +d.dataset.index;
            updateSlider();
        };
    });

    let touchStartX = 0;
    track.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', e => {
        const diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) {
            currentSlide = diff > 0
                ? (currentSlide + 1) % totalSlides
                : (currentSlide - 1 + totalSlides) % totalSlides;
            updateSlider();
        }
    }, { passive: true });
    updateSlider();
})();

(function() {
    const reviewImages = document.querySelectorAll('.review-img');
    const reviewSlider = document.getElementById('reviewSlider');
    const sliderImage = document.getElementById('sliderImage');
    const sliderUser = document.getElementById('sliderUser');
    const sliderStars = document.getElementById('sliderStars');
    const sliderCounter = document.getElementById('sliderCounter');
    if (!reviewSlider || !sliderImage || !reviewImages.length) return;

    let currentReview = 0;

    function updateReviewSlider() {
        const img = reviewImages[currentReview];
        sliderImage.src = img.querySelector('img').src;
        if (sliderUser) sliderUser.textContent = img.dataset.user || '';
        const rating = parseInt(img.dataset.rating, 10) || 5;
        if (sliderStars) {
            let starsHTML = '';
            for (let i = 0; i < 5; i++) {
                starsHTML += i < rating
                    ? '<i class="fas fa-star"></i>'
                    : '<i class="fa-regular fa-star"></i>';
            }
            sliderStars.innerHTML = starsHTML;
        }
        if (sliderCounter) {
            sliderCounter.textContent = (currentReview + 1) + ' / ' + reviewImages.length;
        }
    }

    window.openReviewSlider = function(index) {
        currentReview = index;
        updateReviewSlider();
        reviewSlider.classList.remove('hidden');
        reviewSlider.classList.add('flex');
        document.body.style.overflow = 'hidden';
    };

    window.closeReviewSlider = function() {
        reviewSlider.classList.add('hidden');
        reviewSlider.classList.remove('flex');
        document.body.style.overflow = '';
    };

    window.reviewSliderNav = {
        next() {
            currentReview = (currentReview + 1) % reviewImages.length;
            updateReviewSlider();
        },
        prev() {
            currentReview = (currentReview - 1 + reviewImages.length) % reviewImages.length;
            updateReviewSlider();
        }
    };

    reviewSlider.addEventListener('click', e => {
        if (e.target === reviewSlider) window.closeReviewSlider();
    });

    document.addEventListener('keydown', e => {
        if (reviewSlider.classList.contains('hidden')) return;
        if (e.key === 'Escape') window.closeReviewSlider();
        if (e.key === 'ArrowRight') window.reviewSliderNav.next();
        if (e.key === 'ArrowLeft') window.reviewSliderNav.prev();
    });

    let touchStartX2 = 0;
    reviewSlider.addEventListener('touchstart', e => {
        touchStartX2 = e.touches[0].clientX;
    }, { passive: true });
    reviewSlider.addEventListener('touchend', e => {
        const diff = touchStartX2 - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) {
            if (diff > 0) window.reviewSliderNav.next();
            else window.reviewSliderNav.prev();
        }
    }, { passive: true });
})();

function toggleFaq(btn) {
    const item = btn.closest('.faq-item');
    const content = item.querySelector('.faq-content');
    const icon = btn.querySelector('i');
    const allItems = document.querySelectorAll('.faq-item');
    allItems.forEach(other => { if (other !== item) { other.querySelector('.faq-content').classList.add('hidden'); other.querySelector('.faq-trigger i').classList.remove('rotate-180') } });
    content.classList.toggle('hidden');
    icon.classList.toggle('rotate-180');
}